import React from 'react';
import { Field, ImageField, RichTextField, TextField } from '@sitecore-jss/sitecore-jss-react';
import AboutWrapper, { ITabLinkItem } from '../../components/AboutWrapper/AboutWrapper';
import { ComponentProps } from 'lib/component-props';
import ContentWithMedia from '../../components/ContentWithMedia/ContentWithMedia';
import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import { StNextImage } from '../../components/shared/NextImage.styles';
import ShareAndDownload from '../../components/ShareAndDownload/ShareAndDownload';

interface IContentItem {
  fields?: {
    heading?: TextField;
    subHeading?: TextField;
    content?: RichTextField;
    image?: ImageField;
  };
}
type donwloadItems = {
  value: {
    description: string;
    displayName: string;
    extension: string;
    keywords: string;
    mimeType: string;
    name: string;
    size: string;
    src: string;
    title: string;
  };
};

export type ContentWithOptionsProps = ComponentProps & {
  fields: {
    tabLinks?: ITabLinkItem[];
    activeTab?: ITabLinkItem;
    ContentItemList?: IContentItem[];
    downloadIcon?: ImageField;
    downloadText?: TextField;
    showDownloadOption?: Field<boolean>;
    shareIcon?: ImageField;
    shareText?: TextField;
    showShareOption?: Field<boolean>;
    downloadFile?: donwloadItems;
    fileName?: donwloadItems;
    ShareAndDownload?: any;
  };
};

const fallBackTabItem: ITabLinkItem = {
  id: '',
  url: '',
  name: '',
  displayName: '',
  fields: {
    link: { value: { href: '' } },
  },
};
// const fallbackIcon: ImageField = {
//   value: {
//     src: '',
//   },
// };

export const OptionIconButton: React.FC<{
  tooltipText: string;
  iconImage: ImageField;
  clickHandler?: (e?: any) => void;
}> = ({ tooltipText, iconImage, clickHandler }) => {
  const theme = useTheme();
  return (
    <Tooltip title={tooltipText} placement="top" arrow>
      <IconButton onClick={clickHandler}>
        <StNextImage
          suppressHydrationWarning
          field={iconImage}
          width={20}
          height={25}
          overrideIconColor={`${theme.palette.primary.main}`}
        />
      </IconButton>
    </Tooltip>
  );
};

const ContentWithOptions = (props: ContentWithOptionsProps): JSX.Element => {
  const tabLinks = props?.fields?.tabLinks || [fallBackTabItem];
  const activeTab = props?.fields?.activeTab || fallBackTabItem;
  const contentItemList = props.fields?.ContentItemList;
  // const isShowDownloadOption = props.fields?.showDownloadOption?.value;
  // const isShowShareOption = props.fields?.showShareOption?.value;
  // const downloadIcon = props.fields?.downloadIcon || fallbackIcon;
  // const downloadText = props.fields?.downloadText?.value || '';
  // const shareIcon = props.fields?.shareIcon || fallbackIcon;
  // const shareText = props.fields?.shareText?.value || '';

  const OptionButtons = () => {
    return (
      <div>
        <ShareAndDownload
          params={{
            pageType: 'aboutUs',
          }}
          fields={{
            ...props?.fields?.ShareAndDownload?.fields,
            downloadFile: props?.fields?.downloadFile,
          }}
        />
        {/* {isShowDownloadOption && (
          <OptionIconButton tooltipText={String(downloadText)} iconImage={downloadIcon} />
        )}
        {isShowShareOption && (
          <OptionIconButton tooltipText={String(shareText)} iconImage={shareIcon} />
        )} */}
      </div>
    );
  };

  return (
    <AboutWrapper tabLinks={tabLinks} activeTab={activeTab}>
      {Array.isArray(contentItemList) &&
        contentItemList.map((item, index) =>
          index === 0 ? (
            <ContentWithMedia key={index} fields={item.fields} OptionButtons={OptionButtons} />
          ) : (
            <ContentWithMedia key={index} fields={item.fields} />
          )
        )}
    </AboutWrapper>
  );
};

export default ContentWithOptions;
